module.exports = __webpack_public_path__ + "static/media/DSC00095.9f05a508.jpg";